interface PhoneIconSize36Props {
  className?: string;
}

const defaultProps = {
  className: undefined,
};

function PhoneIconSize36({ className }: PhoneIconSize36Props) {
  return (
    <svg
      className={className}
      fill="none"
      height="36"
      viewBox="0 0 36 36"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1667 33H12.8333C11.275 33 10 31.65 10 30V6C10 4.35 11.275 3 12.8333 3H24.1667C25.725 3 27 4.35 27 6V30C27 31.65 25.725 33 24.1667 33Z"
        fill="#FFB600"
      />
      <path
        clipRule="evenodd"
        d="M15.6667 28.5C15.6667 27.6716 16.3009 27 17.0833 27H19.9167C20.6991 27 21.3333 27.6716 21.3333 28.5C21.3333 29.3284 20.6991 30 19.9167 30H17.0833C16.3009 30 15.6667 29.3284 15.6667 28.5Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M15.6667 6.75C15.6667 6.33579 15.9838 6 16.375 6H20.625C21.0162 6 21.3333 6.33579 21.3333 6.75C21.3333 7.16421 21.0162 7.5 20.625 7.5H16.375C15.9838 7.5 15.6667 7.16421 15.6667 6.75Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

PhoneIconSize36.defaultProps = defaultProps;

export default PhoneIconSize36;
